import { CommonModule } from "@angular/common";
import { Component, Input, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Store } from "@ngrx/store";
import { AnnouncementReciverInterface } from "src/app/shared/interfaces";
import { announcementActions } from "src/app/shared/store";
import { AnnouncementHeadingComponent } from "../announcement-heading/announcement-heading.component";

@Component({
    selector: "sms-announcement-card",
    templateUrl: "./announcement-card.component.html",
    styleUrls: ["./announcement-card.component.scss"],
    standalone: true,
    imports: [CommonModule, AnnouncementHeadingComponent],
})
export class AnnouncementCardComponent implements OnInit {
    @Input() sidebar: boolean = false;
    @Input() url: string;
    @Input() relativeRoute: boolean = false;
    @Input() selectAnnouncementId: string | null = null;
    @Input() item: AnnouncementReciverInterface;
    constructor(
        private store: Store,
        private router: Router,
        private route: ActivatedRoute,
    ) {}

    ngOnInit() {}

    onSelectAnnouncement(item: AnnouncementReciverInterface) {
        console.log("On selcctytctct");
        if (this.url) {
            this.router.navigate([this.url], {
                relativeTo: this.route,
            });
        } else {
            this.store.dispatch(announcementActions.setOneAnnouncement({ data: item }));
        }
        if (!this.sidebar) {
            this.router.navigate([this.router.routerState.snapshot.url, item.id]);
        }
    }
}
